module.exports = __webpack_public_path__ + "img/square-e.b182f3e4.svg";